<template>
  <b-button
    :title="title"
    :style="{ '--color': color }"
    class="matrix-row-button has-text-weight-bold"
    :class="{ active: isOn && !disabled, [code.code]: true }"
    :disabled="disabled"
    :loading="toggling"
    @click="toggle_"
  >
    {{ code.code }}
  </b-button>
</template>

<script>
export default {
  props: {
    code: {
      type: Object,
      required: true
    },
    isOn: {
      type: Boolean,
      default: false
    },
    colors: {
      type: Object,
      default: () => {}
    },
    toggle: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    toggling: false
  }),
  computed: {
    title() {
      return `TYPE: ${this.code.type} | CODE: ${this.code.code} | NAME: ${this.code.name} | GROUP: ${this.code.group || 'N/A'}`;
    },
    color() {
      // Force random color instead of using attributes
      return this.colors[this.code.group];

      // const attribute = this.code.attributes.find(
      //   attribute => attribute.code === "code_type_color"
      // );
      // return attribute ? attribute.value : this.code.typeColor;
    },
    disabled() {
      return !this.code.status;
    }
  },
  methods: {
    async toggle_() {
      this.toggling = true;

      try {
        await this.toggle();

        this.$buefy.toast.open({
          message: "Codes has been associated.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {}

      this.toggling = false;
    }
  }
};
</script>

<style scoped>
.matrix-row-button {
  border-left: 2px solid var(--color);
}
.matrix-row-button.active,
.matrix-row-button:hover {
  background-color: var(--color);
  border-color: var(--color);
}
.matrix-row-button[disabled]:hover {
  border-color: inherit;
  background-color: inherit;
  border-left: 2px solid var(--color);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/CodesMatrixManager/partials/matrixRow.vue